import { formatShortDate } from './format'

/** A day as the date fields write it, "2026-09-15", in local time. */
function localDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

function daysAgo(days: number, now: Date): string {
  return localDate(new Date(now.getFullYear(), now.getMonth(), now.getDate() - days))
}

/** One tap for the usual ranges; Pick dates for the rest. Each gives the first day it covers (`from`), open-ended. */
export const timePresets = [
  { id: 'today', label: 'Today', from: (now: Date) => daysAgo(0, now) },
  // Today counts as the first of the days.
  { id: 'week', label: 'Last 7 days', from: (now: Date) => daysAgo(6, now) },
  { id: 'month', label: 'Last 30 days', from: (now: Date) => daysAgo(29, now) },
] as const

/** What the time chip says for a range: a preset's name, the dates, or "Any time". */
export function timeLabel(from: string, to: string, now: Date = new Date()): string {
  if (!from && !to) return 'Any time'
  const preset = !to ? timePresets.find((p) => p.from(now) === from) : undefined
  if (preset) return preset.label
  const day = (value: string) => formatShortDate(new Date(`${value}T12:00:00`).toISOString(), now)
  if (from && to) return `${day(from)} – ${day(to)}`
  return from ? `From ${day(from)}` : `Until ${day(to)}`
}

/** "2026-09-15" (a day picked, local) as the start of that day; `endOfDay` gives the next midnight, for an end that includes it. */
export function dateToIso(value: string, endOfDay = false): string | undefined {
  if (!value) return undefined
  const [y, m, d] = value.split('-').map(Number)
  return new Date(y, m - 1, d + (endOfDay ? 1 : 0)).toISOString()
}
